module.exports = __webpack_public_path__ + "img/icon_reserv_map.707ecc22.svg";